import React from "react";
import { FormControl, FormGroup, FormLabel } from "react-bootstrap";
import { InputBox } from "../../components";
import { AccountInterface, AffiliateSettingInterface, ApiHelper } from "../../helpers";

interface Props {
  affiliateId: number;
  onDone: () => void
}

export const AffiliateSettings: React.FC<Props> = props => {

  const [account, setAccount] = React.useState<AccountInterface>(null);
  const [settings, setSettings] = React.useState<AffiliateSettingInterface>(null);

  const init = () => {
    ApiHelper.get<AccountInterface>("/accounts/" + props.affiliateId).then(a => setAccount(a));
    ApiHelper.get<AffiliateSettingInterface[]>("/affiliateSettings/" + props.affiliateId).then(s => {
      if (s && s.length > 0) setSettings(s[0])
      else { setSettings({ ownedFeedCommission: 0, screenCommission: 0, accountId: props.affiliateId, code: "", id: 0 }) }
    });
  }

  React.useEffect(init, [props.affiliateId]);


  const handleChange = (e: any) => {
    let s: AffiliateSettingInterface = { ...settings };
    const val = e.currentTarget.value;
    switch (e.currentTarget.id) {
      case "code": s.code = val; break;
      case "screenCommission": s.screenCommission = parseFloat(val.replace("%", "")); break;
      case "ownedFeedCommission": s.ownedFeedCommission = parseFloat(val.replace("%", "")); break;
    }
    setSettings(s);
  }

  const handleSave = () => { ApiHelper.post("/affiliateSettings", [settings]).then(() => { props.onDone() }); }

  const handleCancel = () => { props.onDone(); }

  let screenPercent = (settings?.screenCommission || 0).toString() + "%";
  let feedPercent = (settings?.ownedFeedCommission || 0).toString() + "%";

  return (
    <InputBox headerText={"Affiliate Settings: " + account?.name} headerIcon="fas fa-money-bill-wave" saveFunction={handleSave} cancelFunction={handleCancel}  >
      <FormGroup className="mb-3">
        <FormLabel>Affiliate Code</FormLabel>
        <FormControl id="code" value={settings?.code} onChange={handleChange} />
      </FormGroup>
      <FormGroup className="mb-3">
        <FormLabel>Screen Commission</FormLabel>
        <FormControl id="screenCommission" value={screenPercent} onChange={handleChange} />
      </FormGroup>
      <FormGroup className="mb-3">
        <FormLabel>Owned Feed Commission</FormLabel>
        <FormControl id="ownedFeedCommission" value={feedPercent} onChange={handleChange} />
      </FormGroup>
    </InputBox>
  );

};